(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-homepage-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initHeroSliders() {
      const sliderSections = document.querySelectorAll('.rag-hhs');
      if (!sliderSections.length) return;

      sliderSections.forEach((sectionNode) => {
        if (sectionNode.dataset.sliderInitialized === 'true') return;
        sectionNode.dataset.sliderInitialized = 'true';

        const track = sectionNode.querySelector('.rag-hhs__track');
        const slides = Array.from(sectionNode.querySelectorAll('.rag-hhs__slide'));
        if (!track || !slides.length) return;

        const navCtrl = sectionNode.querySelector('.rag-hhs__controls');
        const prevBtn = sectionNode.querySelector('[data-role="prev"]');
        const nextBtn = sectionNode.querySelector('[data-role="next"]');
        const dotsWrapper = sectionNode.querySelector('.rag-hhs__dots');

        if (slides.length <= 1) {
          if (navCtrl) navCtrl.style.display = 'none';
          if (dotsWrapper) dotsWrapper.style.display = 'none';
          return;
        }

        if (navCtrl) navCtrl.style.display = 'flex';
        if (dotsWrapper) dotsWrapper.style.display = 'flex';

        if (dotsWrapper) {
          dotsWrapper.innerHTML = '';

          slides.forEach((slide, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'page-btn';
            dot.setAttribute('aria-controls', track.id);
            dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
            dot.dataset.index = index;
            dot.innerHTML =
              '<span class="visually-hidden">Go to slide ' + (index + 1) + ' of ' + slides.length + '</span>' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="page-btn__circle">' +
              '<circle class="page-btn__fg-circle" cx="12" cy="12" r="6" />' +
              '<circle class="page-btn__bg-circle" cx="12" cy="12" r="6" />' +
              '</svg>';
            dotsWrapper.appendChild(dot);
          });
        }

        const dots = Array.from(sectionNode.querySelectorAll('.page-btn'));
        let currentIndex = 0;

        const autoplayEnabled = sectionNode.dataset.autoplay === 'true';
        const autoplaySpeedSeconds = parseInt(sectionNode.dataset.autoplaySpeed || '5', 10) || 5;
        const autoplayDelay = autoplaySpeedSeconds * 1000;
        let autoplayTimer = null;

        function goToSlide(index) {
          currentIndex = (index + slides.length) % slides.length;
          track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';

          dots.forEach((dot, i) => {
            dot.setAttribute('aria-current', i === currentIndex ? 'true' : 'false');
          });
        }

        function nextSlide() {
          goToSlide(currentIndex + 1);
        }

        function prevSlide() {
          goToSlide(currentIndex - 1);
        }

        function startAutoplay() {
          if (!autoplayEnabled || autoplayTimer) return;
          autoplayTimer = setInterval(nextSlide, autoplayDelay);
        }

        function stopAutoplay() {
          if (!autoplayTimer) return;
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            stopAutoplay();
            nextSlide();
            startAutoplay();
          });
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            stopAutoplay();
            prevSlide();
            startAutoplay();
          });
        }

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            stopAutoplay();
            goToSlide(parseInt(dot.dataset.index, 10));
            startAutoplay();
          });
        });

        sectionNode.addEventListener('mouseenter', stopAutoplay);
        sectionNode.addEventListener('mouseleave', startAutoplay);

        goToSlide(0);
        startAutoplay();
      });
    }

    document.addEventListener('DOMContentLoaded', initHeroSliders);
    document.addEventListener('shopify:section:load', initHeroSliders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
